import { LocalizedText, showSuccessAlert } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { WithAccountId } from '@mews-commander/types';
import { useInvalidateRepositoryQuery, useRepositoryMutation, useRepositoryQuery } from '@mews-commander/data-access';

export const useGetSettlements = ({ accountId }: WithAccountId) =>
    useRepositoryQuery('settlements', 'getAll', { customerId: accountId });

export const useInvalidateGetSettlements = ({ accountId }: WithAccountId) => {
    const invalidateRepositoryQuery = useInvalidateRepositoryQuery();

    return () => void invalidateRepositoryQuery('settlements', 'getAll', { customerId: accountId });
};

export const useCancelSettlement = ({ accountId }: WithAccountId) => {
    const invalidateGetSettlements = useInvalidateGetSettlements({ accountId });

    return useRepositoryMutation('settlements', 'cancel', {
        transformParams: ({ settlementId }: { settlementId: string; isPreauthorization: boolean }) => ({
            settlementIds: [settlementId],
        }),
        onSuccess: (settlementsCancelResult, { isPreauthorization }) => {
            const { reservationNumber } = settlementsCancelResult[0];
            if (!reservationNumber) {
                return;
            }
            showSuccessAlert({
                description: (
                    <LocalizedText
                        textKey={
                            isPreauthorization
                                ? TextKey.CancelSettlementSuccessMessagePreauth
                                : TextKey.CancelSettlementSuccessMessagePayment
                        }
                        substitutes={{ reservationNumber }}
                    />
                ),
            });

            invalidateGetSettlements();
        },
    });
};
